import { InputCheckboxInstruction, InputDropdownInstruction, InputTextInstruction, StaticTextInstruction } from '@common/instructions/frontend-shared';
import { DynamicFieldsetModule } from '@common/forms/frontend-shared';
import { AppMessagesComponent } from '@common/messages/frontend-shared';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';
import { UiIconsModule } from '@common/ui/frontend-shared/icons';
import { UiInputGroupComponent } from '@common/ui/frontend-shared/input-group';
import { CoreFrontendSharedModule, FormInstructionInterface, LocalMessageHandlerService } from '@core/frontend-shared';
import { MembershipDisplayMode, MembershipRegistrationPluginFormComponent } from '@common/membership/frontend-shared';
import { MembershipRegistrationDataInsurance2025Model } from '@pflegetheke/membership-plugins-insurance/shared';
import { HealthInsuranceItem } from '@common/health-insurances/shared';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../common/forms/frontend-shared/src/lib/simple-fieldset/simple-fieldset.component";
import * as i2 from "../../../../../../../common/forms/frontend-shared/src/lib/form-submit-button/form-submit-button.directive";
const _c0 = a0 => ({
  label: a0
});
function MembershipRegistrationFormInsurance2025Component_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "Die Nutzung der Pflegetheke ist f\u00FCr Sie kostenfrei.");
    i0.ɵɵelementEnd();
  }
}
function MembershipRegistrationFormInsurance2025Component_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1, "Wir ben\u00F6tigen von Ihnen noch einige Angaben, danach k\u00F6nnen Sie direkt loslegen!");
    i0.ɵɵelementEnd();
  }
}
function MembershipRegistrationFormInsurance2025Component_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 5);
    i0.ɵɵlistener("click", function MembershipRegistrationFormInsurance2025Component_Conditional_6_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onReset());
    });
    i0.ɵɵelementEnd();
  }
}
export let MembershipRegistrationFormInsurance2025Component = /*#__PURE__*/(() => {
  class MembershipRegistrationFormInsurance2025Component extends MembershipRegistrationPluginFormComponent {
    getInstructions() {
      const compactLayout = true || this.displayMode === MembershipDisplayMode.compact;
      const labelProp = compactLayout ? 'placeholder' : 'label';
      const instructionConfigPublicInsurance = {
        optionsDynamic: {
          model: HealthInsuranceItem,
          useCrudEndpoint: 'public',
          filter: [{
            field: 'isPrivate',
            operator: '$eq',
            value: false
          }, {
            field: 'enabled',
            operator: '$eq',
            value: true
          }]
        },
        optionValue: 'alias',
        filter: true
      };
      const instructionConfigPrivateInsurance = {
        optionsDynamic: {
          model: HealthInsuranceItem,
          useCrudEndpoint: 'public',
          filter: [{
            field: 'isPrivate',
            operator: '$eq',
            value: true
          }, {
            field: 'enabled',
            operator: '$eq',
            value: true
          }]
        },
        optionValue: 'alias',
        filter: true
      };
      const insuranceMembershipIdHelp = `
			<p>Für die Abrechnung mit der Krankenkasse benötigen wir Ihre Versichertennummer. Sie finden diese auf Ihrer Krankenkassenkarte.</p>
			<div class="ui-margin ui-align-center">
				<img 
					src="https://res.cloudinary.com/pflegetheke/image/upload/v1696854921/pflegetheke/general/krankenkassenkarte-versichertennummer.png"
					alt="Hier finden Sie Ihre Versichertennummer auf der Krankenkassenkarte" width="360"
				>
			</div>`;
      const instructions = [];
      if (this.requireAccountData) {
        instructions.push(new StaticTextInstruction({
          classes: "ui-margin-top",
          text: "<h4>Angaben für Ihren Account</h4>"
        }), new InputTextInstruction({
          formControlName: 'email',
          [labelProp]: this.plugin.getLabelForField('email')
        }), new InputTextInstruction({
          formControlName: 'phone',
          [labelProp]: this.plugin.getLabelForField('phone')
        }));
      }
      instructions.push(new StaticTextInstruction({
        classes: "ui-margin-top",
        text: "<h4>Ihre Krankenversicherung</h4>"
      }), new InputDropdownInstruction({
        formControlName: 'isPrivateInsurance',
        options: [{
          value: false,
          label: 'Gesetzlich'
        }, {
          value: true,
          label: 'Privat'
        }],
        [compactLayout ? 'dropdownPlaceholder' : 'label']: this.plugin.getLabelForField('isPrivateInsurance')
      }), new InputDropdownInstruction({
        ...instructionConfigPublicInsurance,
        formControlName: 'insuranceId',
        [compactLayout ? 'dropdownPlaceholder' : 'label']: this.plugin.getLabelForField('insuranceId'),
        conditional: {
          display: m => !m.isPrivateInsurance
        }
      }), new InputDropdownInstruction({
        ...instructionConfigPrivateInsurance,
        formControlName: 'insuranceId',
        [compactLayout ? 'dropdownPlaceholder' : 'label']: this.plugin.getLabelForField('insuranceId'),
        conditional: {
          display: m => m.isPrivateInsurance
        }
      }), new InputTextInstruction({
        formControlName: 'insuranceMembershipId',
        [labelProp]: this.plugin.getLabelForField('insuranceMembershipId'),
        help: insuranceMembershipIdHelp
      }));
      instructions.push(new StaticTextInstruction({
        classes: "ui-margin-top",
        text: "<h4>Ihre Anschrift</h4>"
      }), new InputTextInstruction({
        formControlName: 'firstName',
        [labelProp]: this.plugin.getLabelForField('firstName')
      }), new InputTextInstruction({
        formControlName: 'lastName',
        [labelProp]: this.plugin.getLabelForField('lastName')
      }), new InputTextInstruction({
        formControlName: 'address',
        [labelProp]: this.plugin.getLabelForField('address')
      }), new InputTextInstruction({
        formControlName: 'zipcode',
        [labelProp]: this.plugin.getLabelForField('zipcode')
      }), new InputTextInstruction({
        formControlName: 'city',
        [labelProp]: this.plugin.getLabelForField('city')
      }));
      instructions.push(new StaticTextInstruction({
        classes: "ui-margin-top",
        text: "<h4>Gepflegte Person</h4>"
      }), new InputCheckboxInstruction({
        formControlName: 'specifyNursedPerson',
        infoText: this.plugin.getLabelForField('specifyNursedPerson')
      }), new StaticTextInstruction({
        classes: "ui-margin-top",
        text: "Bitte geben Sie nachfolgend Informationen zur gepflegten Person an.",
        conditional: {
          display: m => m.specifyNursedPerson
        }
      }), new InputDropdownInstruction({
        formControlName: 'nursed_isPrivateInsurance',
        options: [{
          value: false,
          label: 'Gesetzlich'
        }, {
          value: true,
          label: 'Privat'
        }],
        [compactLayout ? 'dropdownPlaceholder' : 'label']: this.plugin.getLabelForField('nursed_isPrivateInsurance'),
        conditional: {
          display: m => m.specifyNursedPerson
        }
      }), new InputDropdownInstruction({
        ...instructionConfigPublicInsurance,
        formControlName: 'nursed_insuranceId',
        [compactLayout ? 'dropdownPlaceholder' : 'label']: this.plugin.getLabelForField('nursed_insuranceId'),
        conditional: {
          display: m => m.specifyNursedPerson && !m.nursed_isPrivateInsurance
        }
      }), new InputDropdownInstruction({
        ...instructionConfigPrivateInsurance,
        formControlName: 'nursed_insuranceId',
        [compactLayout ? 'dropdownPlaceholder' : 'label']: this.plugin.getLabelForField('nursed_insuranceId'),
        conditional: {
          display: m => m.specifyNursedPerson && m.nursed_isPrivateInsurance
        }
      }), new InputTextInstruction({
        formControlName: 'nursed_insuranceMembershipId',
        [labelProp]: this.plugin.getLabelForField('nursed_insuranceMembershipId'),
        help: insuranceMembershipIdHelp,
        conditional: {
          display: m => m.specifyNursedPerson
        }
      }), new InputTextInstruction({
        formControlName: 'nursed_firstName',
        [labelProp]: this.plugin.getLabelForField('nursed_firstName'),
        conditional: {
          display: m => m.specifyNursedPerson
        }
      }), new InputTextInstruction({
        formControlName: 'nursed_lastName',
        [labelProp]: this.plugin.getLabelForField('nursed_lastName'),
        conditional: {
          display: m => m.specifyNursedPerson
        }
      }));
      instructions.push(new StaticTextInstruction({
        text: "<br>"
      }), new StaticTextInstruction({
        text: "Mit Ihrer Registrierung erhalten Sie einen kostenfreien Zugang für 6 Monate zu unseren Pflegekursen. Die Kosten hierfür werden von Ihrer Pflegekasse übernommen."
      }), new StaticTextInstruction({
        text: "Sie können sich nach diesem Zeitraum erneut anmelden, um den Zugang kostenfrei für weitere sechs Monate zu verlängern. Auch diese Kosten werden von Ihrer Pflegekasse übernommen."
      }), new StaticTextInstruction({
        text: "In unserer <a href=\"/privacy\" target=\"_blank\">Datenschutzerklärung</a> erfahren Sie, wie wir mit Ihren Daten umgehen.<br><br>"
      }), new InputCheckboxInstruction({
        formControlName: 'acceptTerms',
        [labelProp]: compactLayout ? undefined : this.plugin.getLabelForField('acceptTerms'),
        infoText: "Ich habe die <a href=\"/terms\">Allgemeinen Geschäftsbedingungen</a> gelesen und akzeptiere sie."
      }));
      if (this.requireAccountData) {
        // const checkboxInfoText = "Ich bin damit einverstanden, dass meine personenbezogenen Daten gemäß den Datenschutzbestimmungen an Drittanbieter weitergegeben werden dürfen, um weitere Informationen zu Versorgungsthemen zu erhalten.";
        // instructions.push(
        // 	new InputCheckboxInstruction({ 
        // 		formControlName:'allow3rdPartyContact', 
        // 		[labelProp]:compactLayout ? undefined : this.plugin.getLabelForField('allow3rdPartyContact'), 
        // 		infoText:checkboxInfoText
        // 	})
        // )
      }
      return instructions;
    }
    getEditorDefinition() {
      return this.requireAccountData ? 'with-account-fields' : 'default';
    }
    getFormModel() {
      return MembershipRegistrationDataInsurance2025Model;
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMembershipRegistrationFormInsurance2025Component_BaseFactory;
        return function MembershipRegistrationFormInsurance2025Component_Factory(__ngFactoryType__) {
          return (ɵMembershipRegistrationFormInsurance2025Component_BaseFactory || (ɵMembershipRegistrationFormInsurance2025Component_BaseFactory = i0.ɵɵgetInheritedFactory(MembershipRegistrationFormInsurance2025Component)))(__ngFactoryType__ || MembershipRegistrationFormInsurance2025Component);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: MembershipRegistrationFormInsurance2025Component,
        selectors: [["membership-registration-form-insurance-2025"]],
        features: [i0.ɵɵProvidersFeature([LocalMessageHandlerService]), i0.ɵɵInheritDefinitionFeature],
        decls: 9,
        vars: 9,
        consts: [[3, "formService", "instructions"], [1, "ui-margin", "ui-align-center"], ["uiButton", "", "label", "Zur\u00FCcksetzen", "icon", "times", 1, "ui-button-grey", "small"], ["uiButton", "", 1, "ui-button-primary", 3, "formSubmitButton", "formSubmitButtonOptions"], [1, "reset-wrapper"], ["uiButton", "", "label", "Zur\u00FCcksetzen", "icon", "times", 1, "ui-button-grey", "small", 3, "click"]],
        template: function MembershipRegistrationFormInsurance2025Component_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, MembershipRegistrationFormInsurance2025Component_Conditional_0_Template, 2, 0, "p");
            i0.ɵɵconditionalCreate(1, MembershipRegistrationFormInsurance2025Component_Conditional_1_Template, 2, 0, "p");
            i0.ɵɵelement(2, "simple-fieldset", 0)(3, "app-messages");
            i0.ɵɵelementStart(4, "div", 1)(5, "ui-input-group");
            i0.ɵɵconditionalCreate(6, MembershipRegistrationFormInsurance2025Component_Conditional_6_Template, 1, 0, "button", 2);
            i0.ɵɵelement(7, "button", 3);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(8, "div", 4);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.platform === "frontend" ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.platform === "frontend" ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formService", ctx.formService)("instructions", ctx.instructions);
            i0.ɵɵadvance(4);
            i0.ɵɵconditional(ctx.platform === "frontend" ? 6 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("formSubmitButton", ctx.formService)("formSubmitButtonOptions", i0.ɵɵpureFunction1(7, _c0, !ctx.submitsImmediately ? "weiter" : "senden"));
          }
        },
        dependencies: [CoreFrontendSharedModule, DynamicFieldsetModule, i1.SimpleFieldsetComponent, i2.FormSubmitButtonDirective, UiButtonComponent, UiInputGroupComponent, AppMessagesComponent, UiIconsModule],
        styles: ["[_nghost-%COMP%]{width:650px;max-width:95%;display:block;margin:0 auto}\n\n/*# sourceMappingURL=registration-form.component.ts-angular-inline--62.css.map*/"],
        changeDetection: 0
      });
    }
  }
  return MembershipRegistrationFormInsurance2025Component;
})();